// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 21H1V3H23V21ZM7 8C5.89543 8 5 8.89543 5 10V14C5 15.1046 5.89543 16 7 16H11V14H7V10H11V8H7ZM13 8V16H15V10H17V16H19V9.42871C19 8.6058 18.3188 8.00006 17.5557 8H13Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chinese-rectangle-filled')
export default class ChineseRectangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chinese-rectangle-filled',
    }
  }
}
